export default __webpack_public_path__ + "static/media/solution-2-1-desktop.1139b68f.png";